import styled from '@emotion/styled';
import { flexbox, space, compose, flex } from 'styled-system';
import { Box } from '../box';
import { Flex } from '../flex';
import { themeGet, componentThemeGet } from '../../utils/index';
import { breakpoints, mediaQueries, mediaRangeQueries, sizeAliases } from '../../theme';

const SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const generateStyle = (props: any): any => {
    const breakpoints = themeGet('mediaQueries')(props);
    const styles: any = {};

    if (!breakpoints) {
        return styles;
    }

    sizeAliases.concat(['mobile', 'tablet', 'desktop']).forEach((size, index) => {
        if (undefined !== props[size]) {
            const val = props[size];
            const mediaQuery = breakpoints[index];

            if (val === true) {
                styles[mediaQuery] = {
                    flexBasis: 0,
                    flexGrow: 1,
                    maxWidth: '100%'
                };
                return;
            }

            if (val === false) {
                styles[mediaRangeQueries[size]] = {
                    display: 'none'
                };
                return;
            }

            if (val === 'auto') {
                styles[mediaQuery] = {
                    flexBasis: 'auto',
                    flexGrow: 0,
                    maxWidth: 'none'
                };
                return;
            }

            const sizeNum = parseInt(`${val}`, 10);
            const width = `${Math.round((sizeNum / 12) * 10e7) / 10e5}%`;

            styles[mediaQuery] = {
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            };
        }
    });

    return styles;
};

export const pad = (props: any): string => {
    if (props.gutter) {
        return themeGet(`sizes.${props.gutter}`, props.gutter)(props);
    }
    return componentThemeGet('grid', 'margin', '16px')(props);
};

const lastBreakpoint = breakpoints[breakpoints.length - 1];
const lastMediaQuery = mediaQueries[mediaQueries.length - 1];

const StyledGrid = styled(Box)<any>`
    margin-right: auto;
    margin-left: auto;
    padding-right: ${pad};
    padding-left: ${pad};
    ${(props: any) => (props.fluid ? {
        width: '100%'
    } : {
        width: '100%',
        [lastMediaQuery]: {
            maxWidth: lastBreakpoint
        }
    })}
`;

const StyledRow = styled(Flex)<any>`
    margin-right: -${pad};
    margin-left: -${pad};
`;

const StyledCol = styled.div<any>`
    box-sizing: border-box;
    padding-right: ${pad};
    padding-left: ${pad};
    width: 100%;
    ${generateStyle}
`;

export {
    StyledGrid,
    StyledRow,
    StyledCol
};
